import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Neon Breaker's own Firebase project (same project the Flutter game uses).
// Named "neon" so this app instance never collides with the other two
// games' instances in the same page. Web config isn't a secret - Firestore
// Security Rules are the actual access boundary.
const firebaseConfig = {
  apiKey: 'AIzaSyCfjUO30UXBe4TvTi6n6AO41m8cH34HB7Q',
  authDomain: 'neon-breaker-game-8888.firebaseapp.com',
  projectId: 'neon-breaker-game-8888',
  storageBucket: 'neon-breaker-game-8888.firebasestorage.app',
  messagingSenderId: '609907062342',
  appId: '1:609907062342:web:96fbaf64ea7ddec621bc47',
};

export const app = initializeApp(firebaseConfig, 'neon');
export const db = getFirestore(app);
export const auth = getAuth(app);
